import React from "react";
import { Link } from "@/components/common/Link";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { cn } from "@/lib/utils";
const categories = [{
  title: "Scale",
  description: "Elementi architettonici che uniscono funzionalità e design scultoreo, trasformando il passaggio tra gli ambienti in un'esperienza estetica.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1561763/img/image_zz5pgzrj.png",
  alt: "Dettaglio di una scala moderna di design con finiture premium",
  alignment: "right"
}, {
  title: "Tapparelle e Persiane",
  description: "Sistemi oscuranti evoluti che garantiscono privacy e isolamento termico, integrandosi perfettamente con lo stile della facciata.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1561763/img/tapparelle_persiane_premium.png",
  alt: "Persiane moderne in alluminio con lamelle orientabili",
  alignment: "left"
}, {
  title: "Pergole Bioclimatiche",
  description: "Strutture outdoor intelligenti per vivere gli spazi esterni in ogni stagione, regolando luce e ventilazione con eleganza.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1561763/img/pergole_bioclimatiche_outdoor.png",
  alt: "Pergola bioclimatica installata in un giardino moderno",
  alignment: "right"
}, {
  title: "Zanzariere",
  description: "Protezione invisibile e resistente. Soluzioni minimali che preservano la vista e garantiscono il massimo comfort abitativo.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1561763/img/DD43D175-10B7-458A-906C-22EB95ADED63 2.png",
  alt: "Dettaglio di una zanzariera di design installata su un serramento moderno in alluminio",
  alignment: "left"
}, {
  title: "Grate e Inferriate",
  description: "Sicurezza senza compromessi estetici. Design robusto e raffinato per proteggere la tua casa con stile.",
  image: "https://active-phoenix.10web.cloud/wp-content/uploads/2026/03/Schermata-2026-03-06-alle-17.54.49.png?v=vniuk4lswvf",
  alt: "Grate di sicurezza dal design moderno e minimale",
  alignment: "right"
}];
export default function EccellenzaNelDesignParte2() {
  return <section id="eccellenza-nel-design-parte-2" className="bg-white py-32 w-full overflow-hidden">
      <div className="max-w-7xl mx-auto px-8">
        <div className="flex flex-col gap-y-20 md:gap-y-32">
          {categories.map((category, i) => <div key={category.title} data-index={i} className={cn("flex flex-col md:flex-row items-center gap-12 md:gap-24", category.alignment === "right" ? "md:flex-row-reverse" : "")}>
              
              <div className="w-full md:w-1/2">
                <Link to="/" className="block group cursor-pointer">
                  <div className="overflow-hidden rounded-2xl bg-secondary/20">
                    <AspectRatio ratio={1 / 1}>
                      <img src={category.image} alt={category.alt} className="h-full w-full object-cover transition-transform duration-1000 ease-out group-hover:scale-[1.03]" />
                    </AspectRatio>
                  </div>
                </Link>
              </div>

              <div className="w-full md:w-1/2 flex flex-col justify-center items-start text-left">
                <h3 className="text-3xl font-bold mb-6 tracking-tight text-primary md:text-4xl">
                  {category.title}
                </h3>
                <p className="text-lg md:text-xl text-primary leading-relaxed max-w-md font-normal">
                  {category.description}
                </p>
                <div className="mt-8">
                  
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}